import bytes from 'bytes';

/**
 * Maximum allowed file size for SBOM uploads (1 GB).
 */
export const MAX_SBOM_FILE_SIZE = bytes.parse('1GB')!;

/**
 * Maximum allowed file size for Dockerfile uploads (10 MB).
 */
export const MAX_DOCKERFILE_FILE_SIZE = bytes.parse('10MB')!;
